import React, { useEffect, useState } from 'react';
import {
  AlignedPageContainer,
  InsidePageContainer,
  StyledTabAnalytics,
  WhitePageContainerFlex,
} from './common/styles';
import {
  Typography,
  Stack,
  Box,
  Link,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { PROFILES_INFO, TABS_ENUM } from './common/utils';
import ReportsTab from './ReportsTab';
import UsersTab from './UsersTab';
import IntegrationTab from './IntegrationTab';

import { useMatchMakingStore } from './common/store';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const MatchMakingPage = ({ loggedUser, locale }) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).Common;
  const [tabValue, setTabValue] = useState();
  const [currentProfile, users, storeLoggedUser] = useMatchMakingStore(
    (state) => [state.currentProfile, state.users, state.loggedUser]
  );
  const extraMatchmaking = loggedUser.services['Utenze Matchmaking Extra'];
  const isPremium = extraMatchmaking > 0;

  useEffect(() => {
    const showTab = async () => {
      useMatchMakingStore.setState({
        locale,
        currentProfile: isPremium ? PROFILES_INFO.PREMIUM : PROFILES_INFO.BASIC,
        loggedUser,
      });
      const params = new URLSearchParams(location.search);
      const queryTab = params.get('view');
      if (
        queryTab &&
        (queryTab === TABS_ENUM.USERS ||
          queryTab === TABS_ENUM.REPORTS ||
          queryTab === TABS_ENUM.INTEGRATION)
      ) {
        setTabValue(queryTab);
      } else {
        setTabValue(TABS_ENUM.USERS);
      }
    };
    showTab();
  }, []);

  const CustomTabs = () => (
    <Stack flexDirection={isSmDown ? 'column' : 'row'} width={'100%'}>
      <StyledTabAnalytics
        onClick={() => setTabValue(TABS_ENUM.REPORTS)}
        variant="subheadlingMini"
        textAlign={'center'}
        width={isSmDown ? '100%' : '35%'}
        isSelected={tabValue === TABS_ENUM.REPORTS}
        sx={{ fontWeight: tabValue === TABS_ENUM.REPORTS ? 800 : 400 }}
      >
        {i18n.tabReportTitle}
      </StyledTabAnalytics>
      <StyledTabAnalytics
        onClick={() => setTabValue(TABS_ENUM.USERS)}
        variant="subheadlingMini"
        textAlign={'center'}
        width={isSmDown ? '100%' : '35%'}
        isSelected={tabValue === TABS_ENUM.USERS}
        sx={{ fontWeight: tabValue === TABS_ENUM.USERS ? 800 : 400 }}
      >
        {i18n.tabUserTitle}{' '}
        {currentProfile && users ? (
          <Typography
            variant="callout"
            sx={{
              color: theme.palette.primary.main,
              ml: 0.5,
            }}
          >
            {`(${users?.length}/${extraMatchmaking})`}
          </Typography>
        ) : null}
      </StyledTabAnalytics>
      <StyledTabAnalytics
        onClick={() => setTabValue(TABS_ENUM.INTEGRATION)}
        variant="subheadlingMini"
        textAlign={'center'}
        width={isSmDown ? '100%' : '35%'}
        isSelected={tabValue === TABS_ENUM.INTEGRATION}
        sx={{ fontWeight: tabValue === TABS_ENUM.INTEGRATION ? 800 : 400 }}
      >
        {i18n.tabIntegrstionTitle}
      </StyledTabAnalytics>
    </Stack>
  );

  return (
    <div>
      <InsidePageContainer>
        <WhitePageContainerFlex>
          <Typography variant="tittle1" textAlign={'center'}>
            {i18n.title}
          </Typography>
          <Box width="70%">
            <Typography variant="body">{i18n.description}</Typography>
            <Stack
              width="70%"
              direction={'row'}
              alignItems={'center'}
              sx={{
                mt: 1,
                ...(isSmDown && {
                  width: '100%',
                }),
              }}
            >
              <Link
                variant="body"
                href="#"
                underline="always"
                sx={{
                  color: theme.palette.primary.main,
                }}
              >
                {i18n.linkText}{' '}
              </Link>
              <ArrowForwardIcon
                sx={{ color: theme.palette.primary.main, ml: 0.5 }}
              />
            </Stack>
          </Box>
        </WhitePageContainerFlex>
      </InsidePageContainer>
      <CustomTabs />
      <AlignedPageContainer>
        <InsidePageContainer gap={isSmDown ? '20px' : '40px'}>
          {currentProfile && storeLoggedUser?.federationId ? (
            <>
              {tabValue === TABS_ENUM.REPORTS ? (
                <ReportsTab />
              ) : tabValue === TABS_ENUM.USERS ? (
                <UsersTab />
              ) : (
                <IntegrationTab />
              )}
            </>
          ) : null}
        </InsidePageContainer>
      </AlignedPageContainer>
    </div>
  );
};

export default MatchMakingPage;
